// src/components/editions/ReportEditionActions.tsx
//
// The edition controls of a report's header (plan 2026-10-23-an-edition-is-
// an-argument-keyed-snapshot, C6): **Editions** for every reader, **Build
// edition** for who may edit. One component so the dashboard page mounts it
// in one place and a later report top bar can move it whole. Renders nothing
// on a dashboard: editions are a report's (ADR-0496).
import { useState } from "react";
import { Button, Group } from "@mantine/core";
import { useNavigate } from "@/routing/accountRouting";

import type { DashboardDTO } from "@/api/dashboards";
import BuildEditionButton from "./BuildEditionButton";
import EditionsDrawer from "./EditionsDrawer";
import { EDITION_COPY } from "./editionCopy";

export function editionPath(dashboardId: string, editionPublicId: string): string {
  return `/reports/${encodeURIComponent(dashboardId)}/editions/${encodeURIComponent(editionPublicId)}`;
}

export default function ReportEditionActions({ dashboard }: { dashboard: DashboardDTO }) {
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);
  if (dashboard.kind !== "report") return null;
  const mayEdit = !!dashboard.permissions?.edit;
  return (
    <Group gap={6} wrap="nowrap">
      {mayEdit && (
        <BuildEditionButton
          dashboardId={dashboard.id}
          onShowEditions={() => {
            setReloadToken((n) => n + 1);
            setOpened(true);
          }}
        />
      )}
      <Button size="xs" variant="default" onClick={() => setOpened(true)}>
        {EDITION_COPY.editionsButton}
      </Button>
      <EditionsDrawer
        opened={opened}
        onClose={() => setOpened(false)}
        dashboardId={dashboard.id}
        reloadToken={reloadToken}
        onOpenEdition={(edn) => navigate(editionPath(dashboard.id, edn))}
      />
    </Group>
  );
}
